
$ = jQuery;

headerCountDown();

let timer;

function headerCountDown() {
  const headerTopCountdown = $("#header_top_countdown");

  // IF GET HEADER TOP COUNTDOWN
  if (headerTopCountdown) {
    const countDownEnd = headerTopCountdown.attr('data-countdown');
    const now = new Date();
    const endDate = new Date(countDownEnd);
    const difference = endDate.getTime() - now.getTime();

    // IF DATE GREATER THAN TODAY
    if (difference > 0) {
      timer = setInterval(function() {
        timeBetweenDates(endDate);
      }, 1000);
  
      setTimeout(() => {
        headerTopCountdown.css('display', 'inline-block');
      }, 1000);
    }else{
      // ELSE REMOVE COUNTDOWN
      $("body,.nav_container").removeClass("countdown");
      $("#header__countdown").remove();
    }
  }
}

function timeBetweenDates(toDate) {
  const now = new Date();
  const difference = toDate.getTime() - now.getTime();

  if (difference <= 0) {

    // Timer done
    clearInterval(timer);

    // ELSE REMOVE COUNTDOWN
    $("body,.nav_container").removeClass("countdown");
    $("#header__countdown").remove();

  } else {
    
    let seconds = Math.floor(difference / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);

    hours %= 24;
    minutes %= 60;
    seconds %= 60;

    if (days > 0) {
      $("#days").text(days);
    }else{
      $("#days_container").remove();
    }
    
    $("#hours").text(hours);
    $("#minutes").text(minutes);
    $("#seconds").text(seconds);

    if (hours == 0 && days == 0) {
      $("#hours_container").remove();
    }

    if (minutes == 0 && hours == 0 && days == 0) {
      $("#minutes_container").remove();
    }

    if (seconds == 0 && minutes == 0 && hours == 0 && days == 0) {
      $("body,.nav_container").removeClass("countdown");
      $("#header__countdown").remove();
    }
  }
}